import { moment } from "moment";
export const GridDataColumnsSalesGroupModal_Def = [
  { field: "id", headerName: "id", hide: true },
  { field: "UId", headerName: "Code" },
  { field: "Srno", headerName: "SrNo", width: 90 },
  { field: "EMPID", headerName: "Employee ID", width: 120 },
  { field: "EMPNAME", headerName: "Employee Name", width: 350 },
  { field: "Typ", headerName: "Type", width: 100 },
  { field: "Active", headerName: "Active", width: 100 },
];

export const GridDataColumnsEmployeeModal_Def = [
  { field: "id", headerName: "id", hide: true },
  { field: "SrNo", headerName: "SrNo", width: 50 },
  { field: "EMPID", headerName: "Employee ID", width: 120 },
  { field: "SName", headerName: "Name", width: 300 },
  { field: "FName", headerName: "First Name", width: 150, hide: true },
  { field: "LName", headerName: "Last Name", width: 180, hide: true },
  { field: "MName", headerName: "Middle Name", width: 100, hide: true },
  { field: "InActive", headerName: "InActive", width: 60 },
  { field: "JOBTITLE", headerName: "Job Title", width: 80 },
  { field: "Gender", headerName: "Gender", width: 60 },
  {
    field: "DOB",
    headerName: "DOB",
    width: 100,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  { field: "Country", headerName: "Country", width: 120 },
  { field: "Maritial", headerName: "Maritial", width: 60 },
  { field: "Mobile", headerName: "Mobile", width: 120 },
  { field: "Dept", headerName: "Dept", width: 50 },
  { field: "Br", headerName: "Br", width: 50 },
  { field: "Loc", headerName: "Loc", width: 50 },
  {
    field: "EmployementDt",
    headerName: "EmployementDt",
    width: 180,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "DOJ",
    headerName: "DOJ",
    width: 190,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  { field: "Phone", headerName: "Phone", width: 90 },
  { field: "EMail", headerName: "EMail", width: 150 },
  { field: "CompEMail", headerName: "CompEMail", width: 90 },
  { field: "CompPhone", headerName: "CompPhone", width: 90 },
  { field: "CompExt", headerName: "CompExt", width: 90 },
  { field: "CompMobile", headerName: "CompMobile", width: 120 },
  {
    field: "TerminationDt",
    headerName: "TerminationDt",
    width: 90,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
];

var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow = vheaderArrow !== 1 ? vheaderArrow + 1 : 1;

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow = vheaderArrow !== 0 ? vheaderArrow - 1 : 0;
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

export { fRightClick, fLeftClick };
